import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState, UIComponentHandler } from '../../../../../../toolkit/uicomponent';
import { MultiselectCategoryCardComponentProps, MultiselectCategoryCardComponentHandler } from './multiselectcategorycardcomponent';
import { MultiselectCategoryCardCSSStyle } from './multiselectcategorycardcssstyle';
import { CheckboxComponent } from '../../../../../../toolkit/checkbox/checkboxcomponent';
import { CategoryCheckboxCSSStyleImpl } from './multiselectcategorycheckboxcss';
import { BaseContext } from '../../../../../../../utils/basecontext';
import { MultiSelectImageLoaderCSSStyleImpl } from './multiselectimageloadercss';
import { ImageLoaderCSSStyle } from '../../../../../../toolkit/imageloader/imageloadercss';
import { ImageLoaderComponent } from '../../../../../../toolkit/imageloader/imageloadercomponent';
import { CheckboxCSSStyle } from '../../../../../../toolkit/checkbox/checkboxcss';

export class MultiselectCategoryCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private checkboxCssStyle: CheckboxCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = this.getImageLoader(context);
        this.checkboxCssStyle = this.getCheckbox(context);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
    }

    draw(props: MultiselectCategoryCardComponentProps, state: UIComponentState, cssStyle: MultiselectCategoryCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getTintDivCSSStyle()} />
                    {/* <img alt="" src={props.categoryDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/> */}
                    <ImageLoaderComponent defaultImageName={"category_default_image.jpg"} imagePath={props.categoryDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> 
                    {props.isEditable && <div style={cssStyle.getCheckboxCSSStyle()}>
                        <CheckboxComponent isEditable={true} style={this.checkboxCssStyle} onChange={this.onSelected} context={props.context} isChecked={props.isSelected}/>
                    </div>}

                <div style={cssStyle.getTitleCSSStyle()}>
                    {props.categoryDto.getTitle()}
                </div>
            </div>
        );
    }

    getImageLoader(baseContext: BaseContext)
    {
        return new MultiSelectImageLoaderCSSStyleImpl(baseContext);
    }

    getCheckbox(baseContext: BaseContext)
    {
        return new CategoryCheckboxCSSStyleImpl(baseContext);
    }

    onSelected(checked: boolean)
    {
        (this.getUIComponentHandler() as MultiselectCategoryCardComponentHandler).onSelected(checked);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardview.tsx